import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmarPasswordComponent } from './confirmar-password.component';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';

import { FuseSharedModule } from '@fuse/shared.module';

const routes = [
    {
        path     : 'blanqueo-clave',
        component: ConfirmarPasswordComponent
    },

];

@NgModule({
  declarations: [ConfirmarPasswordComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),  
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatRadioModule,
    FuseSharedModule

  ]
})
export class ConfirmarPasswordModule { }
